"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactImageCrop = _interopRequireDefault(require("react-image-crop"));
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
require("react-image-crop/lib/ReactCrop.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var AreaPicker = function AreaPicker(props) {
  var url = props.url,
    areas = props.areas,
    closeModal = props.closeModal;
  var _useState = (0, _react.useState)(areas[0].field.value),
    _useState2 = _slicedToArray(_useState, 2),
    crop = _useState2[0],
    setCrop = _useState2[1];
  var _useState3 = (0, _react.useState)(areas[0].id),
    _useState4 = _slicedToArray(_useState3, 2),
    currentAreaId = _useState4[0],
    setCurrentAreaId = _useState4[1];
  var currentArea = areas.find(function (area) {
    return area.id === currentAreaId;
  });
  var setCurrentArea = function setCurrentArea(area) {
    setCurrentAreaId(area.id);
    setCrop(area.field.value);
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].buttons
  }, areas.map(function (area) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      key: area.id,
      type: "button",
      className: "btn btn-default ".concat(area.id === currentAreaId ? 'active' : ''),
      onClick: function onClick() {
        return setCurrentArea(area);
      }
    }, (0, _cccisdSurveyCommon.stripTags)(area.name));
  })), /*#__PURE__*/_react["default"].createElement(_reactImageCrop["default"], {
    src: url,
    crop: crop,
    onComplete: function onComplete(_, cropPercent) {
      return currentArea.field.onChange(cropPercent);
    },
    onChange: function onChange(_, cropPercent) {
      return setCrop(cropPercent);
    },
    renderSelectionAddon: function renderSelectionAddon() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].name
      }, (0, _cccisdSurveyCommon.stripTags)(currentArea.name));
    },
    style: {
      display: 'block',
      width: '100%'
    },
    imageStyle: {
      width: '100%'
    }
  }, areas.filter(function (area) {
    return area.id !== currentAreaId && area.field.value;
  }).map(function (area) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: area.id,
      className: _style["default"].area,
      onClick: function onClick() {
        return setCurrentArea(area);
      },
      style: {
        left: "".concat(area.field.value.x, "%"),
        top: "".concat(area.field.value.y, "%"),
        width: "".concat(area.field.value.width, "%"),
        height: "".concat(area.field.value.height, "%")
      }
    }, (0, _cccisdSurveyCommon.stripTags)(area.name));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: '1em'
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-primary",
    onClick: closeModal
  }, "Done")));
};
AreaPicker.propTypes = {
  areas: _propTypes["default"].array,
  url: _propTypes["default"].string,
  closeModal: _propTypes["default"].func
};
var _default = exports["default"] = AreaPicker;